/** Shared plan page copy — loading, PIN gate, and banner intro. */
export function sharedPlanIntroMessage(ownerDisplayName: string | null): string {
  if (ownerDisplayName) {
    return `${ownerDisplayName} has shared a financial plan with you`;
  }
  return 'A financial plan has been shared with you';
}

export function sharedPlanLoadingMessage(ownerDisplayName: string | null): string {
  if (ownerDisplayName) {
    return `Loading ${ownerDisplayName}'s Financial Plan`;
  }
  return 'Loading financial plan…';
}
